export const PrivacyPolicyPage = () => {
    const sections = [
        {
            title: "Information We Collect",
            body: "We collect information you provide directly when using Hockeyly, including account credentials, selected matches, and application preferences stored locally in your browser. We do not collect personal player data — all hockey statistics are sourced from the WiseHockey API and processed internally.",
        },
        {
            title: "How We Use Your Information",
            body: "Your information is used solely to provide and improve the Hockeyly platform. This includes authenticating your session, personalising your dashboard experience (e.g. selected matches and tournaments), and generating analytics reports. We do not sell, rent, or share your information with third parties for marketing purposes.",
        },
        {
            title: "Data Storage",
            body: "Session tokens and preferences are stored in your browser's local storage and are never transmitted to third parties. Analytics data is stored in a secured Azure SQL Database accessible only to authorised personnel within Jit Team Sp. z o.o. All data at rest is encrypted.",
        },
        {
            title: "Cookies",
            body: "Hockeyly does not use tracking or advertising cookies. We may use strictly necessary session-related storage to maintain your authenticated state during a browser session.",
        },
        {
            title: "Access & Permissions",
            body: "Access to Hockeyly requires authentication. Production resources are accessible only via VPN. You may request deletion of your account and associated data at any time by contacting your system administrator.",
        },
        {
            title: "Third-Party Services",
            body: "Hockeyly integrates with the WiseHockey API for match and player statistics. Please refer to WiseHockey's own privacy policy for information on how they handle data. We also use Microsoft Azure for cloud infrastructure — data processing remains within the EU.",
        },
        {
            title: "Changes to This Policy",
            body: "We may update this Privacy Policy from time to time. Any changes will be reflected on this page with an updated effective date. Continued use of Hockeyly after changes constitutes acceptance of the updated policy.",
        },
        {
            title: "Contact",
            body: "If you have questions or concerns about this Privacy Policy, please contact Jit Team Sp. z o.o. at the address provided in your service agreement.",
        },
    ];

    return (
        <main className="flex-1 flex flex-col p-4 min-h-0">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-6">
                <div>
                    <h1 className="text-4xl font-black text-primary tracking-tight mb-2 font-headline">
                        Privacy Policy
                    </h1>
                    <p className="text-on-surface-variant font-medium">
                        Effective date: January 1, 2025 &nbsp;·&nbsp; Jit Team Sp. z o.o.
                    </p>
                </div>
            </div>

            <div className="flex flex-col gap-3 pb-8">
                {sections.map((section, i) => (
                    <div
                        key={section.title}
                        className="bg-surface-container-lowest rounded-xl shadow-sm px-6 py-5"
                        style={{ borderLeft: `4px solid ${i % 2 === 0 ? "#050066" : "#ba0a06"}` }}
                    >
                        <p className="font-headline font-black text-[11px] uppercase tracking-widest text-primary mb-2">
                            {section.title}
                        </p>
                        <p className="text-sm text-on-surface-variant leading-relaxed">{section.body}</p>
                    </div>
                ))}
            </div>
            <div className="md:hidden py-6" />
        </main>
    );
};
